import React, { useEffect, useState } from 'react';
import { fetchAttachmentBlob } from './api';

// # ui: dev-feedback-attachment — 첨부 원본은 인증 필수 API 라 Blob 으로 받아 object URL 로 표시한다 (Task2073).

interface AttachmentImageProps {
  attachmentId: number;
  alt: string;
  title?: string;
  className?: string;
  style?: React.CSSProperties;
}

export const AttachmentImage: React.FC<AttachmentImageProps> = ({ attachmentId, alt, title, className, style }) => {
  const [src, setSrc] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let objectUrl: string | null = null;
    let alive = true;
    setSrc(null);
    setFailed(false);
    fetchAttachmentBlob(attachmentId)
      .then((blob) => {
        if (!alive) return;
        objectUrl = URL.createObjectURL(blob);
        setSrc(objectUrl);
      })
      .catch(() => alive && setFailed(true));
    return () => {
      alive = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [attachmentId]);

  if (failed) return <span style={{ fontSize: 12, color: '#999' }}>📎 첨부를 불러오지 못했습니다 (#{attachmentId})</span>;
  if (!src) return <span style={{ fontSize: 12, color: '#999' }}>📎 불러오는 중…</span>;
  return (
    <a href={src} target="_blank" rel="noopener noreferrer" title={title ?? '원본 크기로 새 탭에서 열기'} style={{ display: 'inline-block' }}>
      <img src={src} alt={alt} className={className} style={style} />
    </a>
  );
};
